import React from 'react';
import { Pane } from '@leverege/ui-elements';
import { TableContentView as TableViewer } from '@leverege/molten/data-viewers';
import { Paginator } from '@leverege/molten/screens';
import ResultsTableModel from './ResultsTableModel';
import { jsx as _jsx } from "react/jsx-runtime";
function getItemsFromJob(item) {
  return item?.data?.items ? Object.keys(item?.data?.items).map(k => ({
    data: {
      ...item?.data?.items?.[k]
    },
    id: item?.data?.items?.[k]?.id,
    ref: null,
    type: 'jobItem'
  })) : [];
}
class ResultsTableViewer extends React.Component {
  constructor(props) {
    super(props);
    const {
      sharedProps: {
        parentItem: job
      }
    } = props;
    this.state = {
      page: 0,
      perPage: 100,
      show: job?.data?.data?.state === 'success' ? 'successes' : 'errors'
    };
    this.paginator = new Paginator({
      onPageChange: this.onPageChange
    });
  }
  onPageChange = ({
    page,
    perPage
  }) => {
    this.setState({
      page,
      perPage
    });
  };
  async loadData() {
    const {
      sharedProps: {
        item
      }
    } = this.props;
    const {
      perPage,
      page,
      show
    } = this.state;
    let items = getItemsFromJob(item);
    items = items.filter(i => show === 'errors' ? i?.data?.errorStage != null : i?.data?.errorStage == null);
    this.paginator.setData({
      items,
      count: items.length,
      perPage,
      page
    });
    this.forceUpdate();
  }
  componentDidMount() {
    this.loadData();
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      sharedProps: {
        item
      }
    } = this.props;
    const {
      show
    } = this.state;
    if (prevProps?.sharedProps?.item !== item || show !== prevState?.show) {
      this.loadData();
    }
  }
  fakeDelegate() {
    return {
      getUrl() {
        return false;
      },
      isGotoAllowed() {
        return false;
      }
    };
  }
  filterToErrors = () => this.setState({
    show: 'errors'
  });
  filterToSuccesses = () => this.setState({
    show: 'successes'
  });
  render() {
    const {
      sharedProps: {
        item
      },
      model,
      onChange,
      eventData
    } = this.props;
    const {
      show
    } = this.state;
    if (item == null) {
      return null;
    }
    const onChangeTableModel = ({
      value,
      data
    }) => {
      onChange({
        value: ResultsTableModel[data](model, value),
        data: eventData
      });
    };
    return /*#__PURE__*/_jsx(Pane, {
      style: {
        minHeight: '500px'
      },
      layout: "flex:colL",
      variant: "progressDetail",
      children: /*#__PURE__*/_jsx(TableViewer, {
        loading: false,
        delegate: this.fakeDelegate(),
        paginator: this.paginator,
        objectType: "jobItem",
        settingsData: "setTableModel",
        settings: ResultsTableModel.getTableModel(model),
        onSettingsChange: onChangeTableModel,
        relationship: {
          path: 'test'
        },
        filter: {},
        onFilterChange: () => {},
        parentItem: item,
        filterToErrors: this.filterToErrors,
        filterToSuccesses: this.filterToSuccesses,
        show: show,
        overrides: {
          get: () => null,
          set: () => null
        }
      })
    });
  }
}
export default ResultsTableViewer;
// export default createCardConnect( ResultsTableViewer, ResultsTableModel )